module.exports = __webpack_public_path__ + "9919fcd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/articles/leasing/head-with-key.png
// module id = 3204
// module chunks = 21